/**
 * Componente oficial de logo BAUEN.
 * Usa a arte-final PNG fornecida pelo cliente em /assets/bauen-logo.png.
 * A prop `variant="chip"` envolve a marca num chip claro para preservar
 * cores originais quando renderizado sobre superfícies escuras (dark mode).
 */
export function BauenLogo({ className = "h-9", variant = "chip" }) {
  const Wrapper = variant === "chip" ? "span" : "span";
  const wrapperClass = variant === "chip" ? "bauen-logo-chip" : "";
  return (
    <div className={`inline-flex items-center ${className}`} data-testid="bauen-logo">
      <Wrapper className={wrapperClass}>
        <img
          src="/assets/bauen-logo.png"
          alt="BAUEN — Projeto e Gestão de Obras"
          className="h-full w-auto object-contain bauen-logo-img"
          style={{ height: variant === "chip" ? "26px" : "100%" }}
          draggable={false}
        />
      </Wrapper>
    </div>
  );
}

export function BauenLogoFull({ className = "" }) {
  return (
    <div className={`inline-flex ${className}`} data-testid="bauen-logo-full">
      <img
        src="/assets/bauen-logo.png"
        alt="BAUEN — Projeto e Gestão de Obras"
        className="w-auto object-contain bauen-logo-img"
        style={{ height: "64px" }}
        draggable={false}
      />
    </div>
  );
}
